import { useCallback } from 'react'
import { useFeatureFlagUsageMutation } from './featuresQueries'

const reportedEvaluations = new Set<string>()

export const resetReportedEvaluations = () => {
  reportedEvaluations.clear()
}

export const useFeatureUsageReporter = () => {
  const { mutate } = useFeatureFlagUsageMutation()
  const reportFeatureFlagEvaluation = useCallback(
    (featureId: string, treatment: string) => {
      const evaluationKey = `${featureId}:${treatment}`
      if (reportedEvaluations.has(evaluationKey)) {
        return
      }
      reportedEvaluations.add(evaluationKey)
      mutate({ featureId, treatment })
    },
    [mutate]
  )
  return { reportFeatureFlagEvaluation }
}
